<template>
    <v-card variant="flat" class="px-4 pt-3" style="border-radius: 16px;">
        <v-form ref="form" @submit.prevent="save">
            <v-row>
                <v-col class="px-4 mt-2" cols="12">
                    <div class="d-flex"
                        style="justify-content: space-between !important; align-items: center !important;">
                        <div>
                            <h2 class="main_title">
                               {{ viewType == 'add'?'Add': viewType == 'edit'?'Edit':"" }} <span style=" color: rgb(8, 47, 177);">{{designation}}</span></h2>
                        </div>
                        <span @click="$emit('close')" class="mdi mdi-close"></span>
                    </div>
                </v-col>
            </v-row>

            <v-card-text>
                <v-row class="pa-0 mt-2">
                    <v-col cols="12" class="px-0 py-0 d-flex align-center justify-center">
                        <v-radio-group
                        :disabled="showReadOnly"
                        v-model="formData.status"
                        inline
                        >
                            <v-radio color="primary" label="Active" :value="'Active'"></v-radio>
                            <v-radio color="error" label="Inactive" :value="'Inactive'"></v-radio>
                        </v-radio-group>
                    </v-col>
                    <!-- <v-col cols="4" class="py-0 px-1" v-if="designation === 'Warehouse'">
                        <v-label>Warehouse<span style="color: red;">*</span></v-label>
                        
                        <TextFieldComponent :rules="getRules('Warehouse')" placeholder="First Name"
                            v-model="formData.warehouse_name" />
                    </v-col> -->
                    <v-col cols="4" class="py-0 px-1">
                        <v-label>First Name<span style="color: red;">*</span></v-label>
                        
                        <TextFieldComponent :rules="getRules('First Name')" placeholder="First Name"
                            v-model="formData.first_name" />
                    </v-col>

                    <!-- <v-col cols="4" class="py-0 px-1" v-if="designation === 'Warehouse'">
                        <v-label>First Name<span style="color: red;">*</span></v-label>
                        <TextFieldComponent :rules="getRules('First Name')" placeholder="First Name"
                        v-model="formData.first_name" />
                    </v-col> -->
                    <v-col cols="4" class="py-0 px-1">
                        <v-label>Middle Name</v-label>
                        <TextFieldComponent placeholder="Middle Name" v-model="formData.middle_name" />
                    </v-col>

                    <v-col cols="4" class="py-0 px-1">
                        <v-label>Last Name<span style="color: red;">*</span></v-label>
                        <TextFieldComponent :rules="getRules('Last Name')" placeholder="Last Name" v-model="formData.last_name" />
                    </v-col>
                    <v-col cols="6" class="py-0 px-1">
                        <v-label>Mobile</v-label>
                        <TextFieldComponent placeholder="Mobile" type="number" v-model="formData.mobile" />
                    </v-col>
                    <v-col cols="6" class="py-0 px-1">
                        <v-label>Designation</v-label>
                       
                        <EnumAutoComplete
                            :domain="'KCS_DESIGNATION'"
                            @changeEnumData="changeTitle($event)"
                            :rules="enumErrorRule" 
                            ref="newenum"
                            placeholder="Designation"
                            v-model="formData.designation" 
                            :selected="formData.designation"
                            :showReadOnly="(designation == 'CSR & Leads' || designation == 'Executive Management') ?  false : true"   
                            :type="true"
                        />
                    </v-col>


                    <v-col cols="12" class="py-0 px-1">
                        <v-label>Email<span style="color: red;">*</span></v-label>
                        <TextFieldComponent :rules="getRules('Email')" placeholder="Email" v-model="formData.email"/>     
                        <!-- <v-icon @click="addEmail">mdi-plus</v-icon> -->
                        <!-- <div class="email-list mt-4">
                            <v-chip
                                v-for="(email, index) in emails"
                                :key="index"
                                closable
                                class="ma-1 chip"
                                @click:close="removeEmail(index)"
                            >
                                {{ email }}
                            </v-chip>
                        </div> -->
                    </v-col>

                    <v-col cols="12" class="py-0 px-1" v-if="designation === 'Salesperson' || designation === 'Production Owners'">
                        <v-label>Description</v-label>
                        <!-- <TextFieldComponent placeholder="Comments" v-model="formData.comments"/>      -->
                        <v-textarea placeholder="Description" variant="outlined" :rows="3"
                            v-model="formData.comments"></v-textarea>
                    </v-col>
                   
                    
                    <!-- <v-col cols="6" class="py-0 px-1">
                        <v-label>Status</v-label>
                        <AutoComplete :rules="getRules('Status')" placeholder="Status" v-model="formData.status"
                            :items="active" />
                    </v-col> -->

                    <v-row class="pa-3 mt-0" v-if="designation === 'Executive Management'">
                    <v-col cols="12" class="px-1">
                        <h2 class="main_title">Preferences</h2>
                    </v-col>
                    <!-- Preferred Method -->
                    <v-col cols="6" class="py-1 px-1">
                        <p style="margin-bottom: 10px;">Preferred Method</p>
                        <v-btn-toggle v-model="formData.preferred" border color="#560FFE" rounded="0" divided>
                            <v-btn value="Whatsapp">
                                Whatsapp
                            </v-btn>

                            <v-btn value="Teams">
                                Teams
                            </v-btn>

                            <v-btn value="Email">
                                Email
                            </v-btn>
                        </v-btn-toggle>
                    </v-col>

                    <!-- Presentation Style -->
                    <v-col cols="6" class="py-1 px-1">
                        <p style="margin-bottom: 10px;">Presentation Style</p>
                        <v-btn-toggle v-model="formData.presentation" border color="#560FFE" rounded="0" divided>
                            <v-btn value="Summary First">
                                Summary First
                            </v-btn>

                            <v-btn value="Details First">
                                Details First
                            </v-btn>
                        </v-btn-toggle>
                    </v-col>
                    <!-- Tolearance to mistakes -->
                    <v-col cols="6" class="py-1 px-1">
                        <p style="margin-bottom: 10px;">Tolearance to mistakes</p>
                        <v-btn-toggle v-model="formData.tolearance" border color="#560FFE" rounded="0" divided>
                            <v-btn value="Proactive">
                                Proactive
                            </v-btn>

                            <v-btn value="On Equest">
                                On Request
                            </v-btn>
                        </v-btn-toggle>
                    </v-col>

                    <!-- Doc. Preference -->
                    <v-col cols="6" class="py-1 px-1">
                        <p style="margin-bottom: 10px;">Doc. Preference</p>
                        <v-btn-toggle v-model="formData.doc" border color="#560FFE" rounded="0" divided>
                            <v-btn value="Xlsx">
                                Xlsx
                            </v-btn>

                            <v-btn value="PDF">
                                PDF
                            </v-btn>

                            <!-- <v-btn value="Details First">
                                Details First
                            </v-btn> -->
                        </v-btn-toggle>
                    </v-col>

                    <!-- Teach & Train -->
                    <v-col cols="6" class="py-1 px-1">
                        <p style="margin-bottom: 10px;">Teach & Train</p>
                        <v-btn-toggle v-model="formData.teach" border color="#560FFE" rounded="0" divided>
                            <v-btn value="Willing">
                                Willing
                            </v-btn>

                            <v-btn value="Moderate">
                                Moderate
                            </v-btn>
                        </v-btn-toggle>
                    </v-col>

                    <!-- Clarity in communication -->
                    <v-col cols="6" class="py-1 px-1">
                        <p style="margin-bottom: 10px;">Clarity in communication</p>
                        <v-btn-toggle v-model="formData.clarity" border color="#560FFE" rounded="0" divided>
                            <v-btn value="Explicit">
                                Explicit
                            </v-btn>
                            <v-btn value="Implicit">
                                Implicit
                            </v-btn>
                        </v-btn-toggle>
                    </v-col>

                    <!-- Meeting Window -->
                    <v-col cols="7" class="py-1 px-1">
                        <p style="margin-bottom: 10px;">Meeting Window</p>
                        <v-btn-toggle v-model="formData.meeting" border color="#560FFE" rounded="0" divided>
                            <v-btn value="Meeting">
                                Meeting
                            </v-btn>

                            <v-btn value="Appointment">
                                Appointment
                            </v-btn>
                        </v-btn-toggle>
                    </v-col>
                    <v-col cols="12" class="py-3 px-1">
                        <v-label>Expectations</v-label>
                        <v-textarea placeholder="Expectations" variant="outlined" :rows="3"
                            v-model="formData.expectations" :rules="getRules('Expectations')"></v-textarea>
                       
                    </v-col>
                    </v-row>

                    <v-row v-else>
                    </v-row>

                </v-row>
            </v-card-text>
            <v-col cols="12" align="end">
                <v-btn @click="$emit('close')" class="cancel mr-3" color="gray">
                    Cancel
                </v-btn>
                <v-btn type="submit" class="save" color="rgb(8, 47, 177)">Save</v-btn>
            </v-col>
        </v-form>
    </v-card>
</template>

<script>
// import AutoComplete from "@/components/ui/AutoComplete.vue";
import TextFieldComponent from "@/components/TextFieldComponent.vue";
import EnumAutoComplete from "@/components/others/EnumAutoComplete.vue";

export default {
    components: {
        // AutoComplete,
        TextFieldComponent,
        EnumAutoComplete,
    },
    data: () => ({
        emails: [],
        enumErrorRule: [(value) => (!!value) || "Designation Is Required"],
        formData: {
            first_name:null,
            middle_name:null,
            last_name:null,
            email:[],
            mobile:null,
            designation:null,
            status:null,
            preferred:null,
            presentation:null,
            tolearance:null,
            doc:null,
            teach:null,
            clarity:null,
            meeting:null,
        },
        // leadsTypes: ["Owner", "Co-Owner","Process Lead","Managers", "Sr.Manager", "Assistant Manager","Team Lead","Assistant Team Lead","Process Associate","Salesperson","Production Owners","CSR"],
        active: ["Active", "In Active"],
    }),
    props:['designation','editLocationData','index','viewType'],
    async created() {   
        if(this.viewType == 'edit'){
        this.formData = this.editLocationData
        this.emails = this.formData.email
        }else{
            this.formData = {}
        }
        // console.log(this.editLocationData.designation,"this.editLocationData.designation")
       this.formData.designation = this.designation == 'Process Lead' ? "Process Lead" : this.designation == 'Process Associate' ? "Process Associate" :this.designation == 'Salesperson' ? "Salesperson":this.designation == 'Production Owners' ? "Production Owners":this.editLocationData.designation
                console.log(this.editLocationData.designation,"this.editLocationData.designation")

  },
    methods: {
        // addEmail() {
        //     if (this.formData.email) {
        //         this.emails.push(this.formData.email);
        //         this.formData.email = '';
        //     } else {
        //         console.log('Please enter a valid email address');
        //     }
        // },
        changeTitle($event) {
          this.formData.designation = $event;
        },
        removeEmail(index) {
            this.emails.splice(index, 1);
            console.log(this.emails,"this.emails")
        },
        getRules(name) {
            if (name && name.toLowerCase() === "email") {
                return [
                    (v) => !!v || "E-mail is required.",
                    (v) => /.+@.+\..+/.test(v) || "E-mail must be valid.",
                ];
            }
            return [(v) => !!v || `${name} is required.`];
        },
        async save() {
            if (this.formData.email) {
                let emails = [];

                if (typeof this.formData.email === 'string') {
                    emails = this.formData.email
                    .split(',')
                    .map(email => email.trim())
                    .filter(email => email !== '');
                }

                else if (Array.isArray(this.formData.email)) {
                    emails = this.formData.email.map(email => email.trim());
                }

                this.emails = [...new Set([...(this.emails || []), ...emails])];
                }
            this.formData.email = this.emails
            const validation = await this.$refs.form.validate();
            if (!validation.valid) {
                console.log("Form not valid");
            } else {

                 if(this.viewType == "edit"){
                    this.$emit("update-location",this.formData,this.index,this.designation)
                }else{
                    this.$emit("save", this.formData,this.designation);
                }
                this.formData = {};
                this.$emit("close");
            }
        },
    },

    mounted(){
        if (!this.formData.status) {
    this.formData.status = "Active"
  }
  console.log(this.formData, "!!ssds")
    }
};
</script>
<style scoped>
.chip{
    background-color: #082fb1c4;
    color: #fff;
}
.v-label {
    margin-bottom: 3px;
    font-size: 14px;
    opacity: 1;
    font-weight: 600;
}

.main_title {
    font-size: 16px;
    font-weight: 600;
}

.v-btn-toggle .v-btn {
    background-color: #E9DFFF;

}

.v-btn-toggle {
    height: 32px !important;
}
</style>
